<template lang="html">
  <!-- Projects -->
  <section>
    <div class="columns">
      <!-- Left menu -->
      <div class="column is-one-fifth">
        <div class="box">
          <h1 class="title is-size-5">Advanced search</h1>
          <!-- Title -->
          <b-field label="Title:">
            <b-input placeholder="e.g. Bright like the sun" v-model="name"></b-input>
          </b-field>
          <!-- Character -->
          <b-field label="Character:">
            <b-input placeholder="e.g. Sakura Kinomoto"></b-input>
          </b-field>
          <!-- Version -->
          <b-field label="Version:">
            <b-input placeholder="e.g. Matsuri"></b-input>
          </b-field>
          <!-- Universe -->
          <b-field label="Universe:">
            <b-input placeholder="e.g. Bleach"></b-input>
          </b-field>
          <!-- Teacher -->
          <b-field label="Teacher:">
            <b-input placeholder="e.g. Kamui Cosplay"></b-input>
          </b-field>
          <!-- Languages -->
          <b-field label="Language(s):">
            <b-taginput v-model="tags" ellipsis icon="label" placeholder="Add a tag">
            </b-taginput>
          </b-field>
          <!-- Creation date -->
          <template>
            <b-field label="Creation date">
              <b-datepicker placeholder="Click to select..." v-model="dates" range>
              </b-datepicker>
            </b-field>
          </template>
          <!-- Skills -->
          <b-field label="Skills learned:">
            <b-taginput v-model="tags" ellipsis icon="label" placeholder="Add a tag">
            </b-taginput>
          </b-field>
          <!-- Tags -->
          <b-field label="Tags:">
            <b-taginput v-model="tags" ellipsis icon="label" placeholder="Add a tag">
            </b-taginput>
          </b-field>

          <b-button icon-left="magnify" class="is-primary"> Search </b-button>
        </div>
      </div>

      <!-- Results -->
      <div class="column">
        <div class="columns is-centered is-multiline">
          <div class="column is-11">
            <div class="box">
              <article class="media">
                <figure class="media-left">
                  <b-tooltip label="Aetheya Cosplay">
                    <a class="image is-64x64">
                      <img
                        style="border-radius: 50%"
                        src="https://costuto-public.s3.eu-central-1.amazonaws.com/images/placeholder_1x1.png"
                      />
                    </a>
                  </b-tooltip>
                </figure>

                <div class="media-content">
                  <div class="content">
                    <p>
                      <a class="has-text-dark"
                        ><strong class="">Miku in her wonderful dress</strong><br
                      /></a>
                      <small>Hatsune Miku ver. Append from Vocaloid</small>
                    </p>
                  </div>
                </div>

                <div class="media-right has-text-right">
                  <a
                    ><b-tooltip label="Save Craft" type="is-primary"
                      ><b-icon
                        type="is-primary"
                        icon="star-four-points-outline"
                      ></b-icon></b-tooltip
                  ></a>
                  <a
                    ><b-tooltip label="Follow Teacher" type="is-primary"
                      ><b-icon
                        type="is-primary"
                        icon="eye-plus-outline"
                      ></b-icon></b-tooltip
                  ></a>
                  <b-dropdown aria-role="list" position="is-bottom-left">
                    <p class="clickable" slot="trigger" role="button">
                      <b-icon type="is-gray" icon="dots-vertical"></b-icon>
                    </p>
                    <b-dropdown-item aria-role="listitem">Report user</b-dropdown-item>
                    <b-dropdown-item aria-role="listitem">Block user</b-dropdown-item>
                  </b-dropdown>
                  <br />
                  <b-tooltip
                    type="is-light"
                    position="is-bottom"
                    label="10/02/2020 7:12:34"
                    animated
                  >
                    <small class="has-text-gray">10 min ago</small>
                  </b-tooltip>
                </div>
              </article>

              <div class="columns">
                <div class="column">
                  <span class="heading is-size-7 has-text-dark-orange">Description</span>
                  <b-tooltip type="is-gray" label="Overview of the project"
                    ><b-icon
                      type="is-gray"
                      size="is-small"
                      icon="help-circle-outline"
                    ></b-icon
                  ></b-tooltip>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. <br />
                    Nulla accumsan, metus ultrices eleifend gravida, nulla nunc varius
                    lectus, nec rutrum justo nibh eu lectus. <br />
                    Ut vulputate semper dui. Fusce erat odio, sollicitudin vel erat vel,
                    interdum mattis neque.
                  </p>

                  <b-collapse
                    :open="false"
                    position="is-bottom"
                    aria-id="contentIdForA11y1"
                  >
                    <a
                      slot="trigger"
                      slot-scope="props"
                      aria-controls="contentIdForA11y1"
                    >
                      <b-icon :icon="!props.open ? 'menu-down' : 'menu-up'"></b-icon>
                      {{ !props.open ? "More" : "Less" }}
                    </a>

                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit. <br />
                      Nulla accumsan, metus ultrices eleifend gravida, nulla nunc varius
                      lectus, nec rutrum justo nibh eu lectus. <br />
                      Ut vulputate semper dui. Fusce erat odio, sollicitudin vel erat vel,
                      interdum mattis neque.
                    </p>
                  </b-collapse>
                  <span class="heading is-size-7 has-text-dark-orange">Skills</span>
                  <b-tooltip
                    type="is-gray"
                    label="Skills improved by learning from this tutorial"
                    ><b-icon
                      type="is-gray"
                      size="is-small"
                      icon="help-circle-outline"
                    ></b-icon
                  ></b-tooltip>
                  <p class="tags">
                    <b-tag class="is-primary">Thermoplastics</b-tag>
                    <b-tag class="is-primary">Sewing</b-tag>
                    <b-tag class="is-primary">Casting</b-tag>
                  </p>
                </div>
              </div>

              <div class="columns">
                <div class="column is-paddingless is-marginless">
                  <div class="columns is-marginless is-paddingless is-multiline">
                    <div class="column has-text-left is-full">
                      <div class="columns is-marginless is-paddingless is-vcentered">
                        <div class="column is-marginless is-paddingless">
                          <div class="buttons">
                            <b-button
                              type="is-dark-orange is-outlined"
                              rounded
                              icon-left="wrench"
                              >10</b-button
                            >
                            <b-button
                              type="is-dark-orange is-outlined"
                              rounded
                              icon-left="cart"
                              >7</b-button
                            >
                            <b-button
                              type="is-dark-orange is-outlined"
                              rounded
                              icon-left="comment-question"
                            >
                              8</b-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="column has-text-centered is-full">
                      <figure class="image content">
                        <img
                          style="border-radius: 5%"
                          src="https://costuto-public.s3.eu-central-1.amazonaws.com/images/placeholder_1x1.png"
                          alt=""
                        />
                      </figure>
                    </div>
                    <div class="column is-full">
                      <p class="heading is-size-7 has-text-dark-orange">Tags</p>

                      <b-taglist class="">
                        <b-tag type="is-light-orange">First</b-tag>
                        <b-tag type="is-light-orange">Second</b-tag>
                        <b-tag type="is-light-orange">Third</b-tag>
                        <b-tag type="is-light-orange">Fourth</b-tag>
                        <b-tag type="is-light-orange">Fifth</b-tag>
                      </b-taglist>
                    </div>
                  </div>
                </div>
                <div class="column is-3 is-paddingless is-marginless">
                  <div class="columns is-marginless is-paddingless is-multiline">
                    <div class="column has-text-centered is-full">
                      <b-icon type="is-primary" icon="chevron-up"></b-icon>
                    </div>
                    <div class="column is-full">
                      <figure class="image content">
                        <img
                          style="border-radius: 10%"
                          src="https://costuto-public.s3.eu-central-1.amazonaws.com/images/placeholder_1x1.png"
                          alt=""
                        />
                      </figure>
                    </div>
                    <div class="column is-full">
                      <figure class="image content">
                        <img
                          style="border-radius: 10%"
                          src="https://costuto-public.s3.eu-central-1.amazonaws.com/images/placeholder_1x1.png"
                          alt=""
                        />
                      </figure>
                    </div>
                    <div class="column is-full">
                      <figure class="image content">
                        <img
                          style="border-radius: 10%"
                          src="https://costuto-public.s3.eu-central-1.amazonaws.com/images/placeholder_1x1.png"
                          alt=""
                        />
                      </figure>
                    </div>
                    <div class="column has-text-centered is-full">
                      <b-icon type="is-primary" icon="chevron-down"></b-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right menu -->
      <div class="column is-one-fifth">
        <!-- Footer -->
        <div class="box">
          <figure class="image">
            <img
              src="https://costuto-public.s3.eu-central-1.amazonaws.com/images/tanukos.png"
            />
          </figure>
          <small><strong>Costuto</strong> ©2020</small><br />
          <small>All Rights Reserved</small><br />
          <a href="#"><b-icon icon="twitter" size="is-small"></b-icon></a>
          <a href="#"><b-icon icon="youtube" size="is-small"></b-icon></a>
          <a href="#"><b-icon icon="facebook" size="is-small"></b-icon></a>
          <a href="#"><b-icon icon="instagram" size="is-small"></b-icon></a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {}
}
</script>

<style lang="css" scoped></style>
